import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useCookieConsentContext } from "@use-cookie-consent/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useScrollLock } from "../../../contexts/lockScroll";
import { Button } from "../../../components/buttons/buttons";
import { cookies } from "../translations";
import "./cookie-banner.scss";

const CookieBanner = () => {

  const intl = useIntl();
  const { acceptCookies, consent } = useCookieConsentContext();
  const { lockScroll, unlockScroll } = useScrollLock();

  const [ openModal, setOpenModal ] = useState<boolean>(consent.thirdParty === undefined);
  const [ formThird, setFormThird ] = useState<boolean>(consent.thirdParty ?? true);

  useEffect(() => {
    if (openModal) lockScroll();
    else unlockScroll();
  }, [ openModal ]);

  const onAccepted = (thirdParty: boolean) => {
    (formThird != thirdParty) && setFormThird(thirdParty);
    acceptCookies({ firstParty: true, thirdParty });
    setOpenModal(false);
  }

  return (
    <>
      <span className="rgpd linkable" onClick={() => !openModal && setOpenModal(true)}>
        {intl.formatMessage(cookies.title)}
      </span>
      {openModal &&
        <div className="cookie-banner">
          <h3>{intl.formatMessage(cookies.title)}</h3>
          <p>{intl.formatMessage(cookies.intro)}</p>
          <form>
            <div className="cookie-banner-cookie firstParty">
              <input className="read-only" type="checkbox" checked readOnly />
              <label htmlFor="first">{intl.formatMessage(cookies.firstLabel)}</label>
              <p>{intl.formatMessage(cookies.firstDesc)}</p>
              <ul>
                <li>
                  <span className="title">Stripe</span>
                  <div>
                    <span className="type">{intl.formatMessage(cookies.stripe)}</span>
                    <a href="https://stripe.com/cookie-settings" target="_blank" tabIndex={-1}>
                      <FontAwesomeIcon icon={faCircleInfo} color="var(--red)" />
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            <div className="cookie-banner-cookie thirdParty">
              <input type="checkbox" checked={formThird} onChange={e => setFormThird(e.target.checked)} />
              <label htmlFor="first">{intl.formatMessage(cookies.thirdLabel)}</label>
              <p>{intl.formatMessage(cookies.thirdDesc)}</p>
              <ul>
                <li>
                  <span className="title">Google Analytics</span>
                  <div>
                    <a href="https://policies.google.com/technologies/cookies" target="_blank" tabIndex={-1}>
                      <FontAwesomeIcon icon={faCircleInfo} color="var(--red)" />
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            <div className="cookie-banner-btn">
              <Button onClick={() => onAccepted(formThird)}>{intl.formatMessage(cookies.save)}</Button>
              <Button onClick={() => onAccepted(true)}>{intl.formatMessage(cookies.acceptAll)}</Button>
            </div>
          </form>
        </div>
      }
    </>);

};

export default CookieBanner;
